import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { computeTextColorForBackground, formatDate } from '@aa/ts/common';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
  orderActions,
} from '@aa/angular/core';
import { CustomerAppState } from '../../state/index.reducers';
import { lastValueFrom } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {
  ORDER_STATUS,
  OrderResourceTypeMappings,
} from '@aa/nest/resource/objects';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NextStepsComponent } from '../next-steps/next-steps.component';

@Component({
  selector: 'aa-order-list-card',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
  ],
  templateUrl: './order-list-card.component.html',
  styleUrl: './order-list-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderListCard {
  @Input({ required: true })
  order!: OrderResourceTypeMappings['resourceWithRelationsT'];
  @Input()
  asHeader = false;

  constructor(
    private readonly store: Store<CustomerAppState>,
    private readonly dialog: MatDialog,
  ) {}

  ngOnChanges() {
    console.log('ORDER', this.order);
  }

  isDraft() {
    return this.order.orderStatusId == ORDER_STATUS.DRAFT;
  }

  async promptDelete() {
    const data: ConfirmDialogData = {
      title: 'Are you sure you want to delete this item?',
      subtitle: 'This action cannot be undone.',
    };
    const confirmation = await lastValueFrom(
      this.dialog
        .open(ConfirmDialogComponent, {
          autoFocus: false,
          data,
        })
        .afterClosed(),
    );

    if (confirmation) {
      this.store.dispatch(orderActions.deleteItem({ id: this.order.id }));
    }
  }

  async showShippingInstructions() {
    await lastValueFrom(
      this.dialog
        .open(NextStepsComponent, {
          autoFocus: false,
          data: {
            orderId: this.order.id,
          },
          maxWidth: 'calc(100vw - 1rem)',
          maxHeight: 'calc(100vh - 1rem)',
        })
        .afterClosed(),
    );
  }

  formatDate = formatDate;
  computeTextColorForBackground = computeTextColorForBackground;
}
